<template>
  <div class="authorize-agent">
    <template v-if="error">
      <p class="authorize-error mb-3">{{ error }}</p>
      <b-button variant="primary" class="h-40px px-4" @click="approve">
        {{ $t("authorizeAgent.tryAgain") }}
      </b-button>
    </template>
    <template v-else>
      <b-spinner variant="main" class="loader" type="grow" label="Spinning"></b-spinner>
      <p class="authorize-note mt-3 mb-0">{{ $t("authorizeAgent.connecting") }}</p>
    </template>
  </div>
</template>
<script>
import { mapActions } from "vuex";

// The app's own query keys, which the authorization request knows nothing about.
const APP_QUERY_KEYS = ["lang", "geotabAddin"];

export default {
  name: "AuthorizeAgent",
  data() {
    return {
      error: "",
    };
  },
  methods: {
    ...mapActions(["approveMcpAgent", "setNotification"]),
    requestPayload() {
      const query = this.$route.query || {};
      return Object.keys(query).reduce((payload, key) => {
        if (APP_QUERY_KEYS.includes(key)) return payload;
        const value = query[key];
        payload[key] = Array.isArray(value) ? value[0] : value;
        return payload;
      }, {});
    },
    async approve() {
      this.error = "";
      const payload = this.requestPayload();
      if (!payload.client_id || !payload.redirect_uri) {
        this.error = this.$t("authorizeAgent.badRequest");
        return;
      }
      try {
        const data = await this.approveMcpAgent(payload);
        const redirect = data && data.redirect_to;
        if (!redirect) {
          this.error = this.$t("authorizeAgent.failed");
          return;
        }
        // It leaves the app entirely, so this is a location change rather than
        // a route push.
        window.location.href = redirect;
      } catch (error) {
        this.error = this.apiError(error);
      }
    },
    apiError(error) {
      if (typeof error === "string") return error;
      if (error && error.error) return Array.isArray(error.error) ? error.error[0] : error.error;
      if (error && error.detail) return error.detail.error || error.detail;
      const first = error && Object.values(error)[0];
      if (Array.isArray(first)) return first[0];
      return first || this.$t("authorizeAgent.failed");
    },
  },
  created() {
    this.approve();
  },
};
</script>
<style scoped>
/* Nothing of the app shows through: no sidebar, no header, just white. */
.authorize-agent {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background-color: #ffffff;
  text-align: center;
}

.authorize-note {
  font-size: 14px;
  color: #6c757d;
}

.authorize-error {
  max-width: 420px;
  font-size: 14px;
  color: #ff0000;
}
</style>
